import styled from 'styled-components';
import * as Slider from '@radix-ui/react-slider';
import { colors } from '@/styles';

export const Container = styled.div`
  flex: 1;
`;

export const Root = styled(Slider.Root)`
  position: relative;
  display: flex;
  align-items: center;
  user-select: none;
  touch-action: none;
  width: 100%;
  height: 20px;
`;

export const Track = styled(Slider.Track)`
  background-color: ${colors.secondary.lightGray2};
  position: relative;
  flex-grow: 1;
  height: 8px;
  border-radius: 4px;
`;

export const Range = styled(Slider.Range)`
  position: absolute;
  background-color: ${colors.secondary.darkGray1};
  height: 100%;
  border-radius: 4px;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
`;

export const Thumb = styled(Slider.Thumb)`
  display: block;
  width: 15px;
  height: 15px;
  background-color: white;
  border: 2px solid #111;
  border-radius: 50%;
  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.2);
  }
`;
